import { useEffect } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@nazka/nazka.mapframe.components';

import TranslationsProvider, { LocalizedRoutes } from '@utils/i18n/i18n';
import WindowObserver from '@utils/WindowObserver/WindowObserver';
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary';
import MapSwitch from '@App/components/MapSwitch/MapSwitch';

import maplibregl from 'maplibre-gl';
import { Protocol } from 'pmtiles';

import routes from '@App/app.routes';
import store from '@App/app.store';
import translator from '@App/app.translator';

import theme from '@css/theme.style.json';

import './app.styl';

function App() {
  useEffect(() => {
    const protocol = new Protocol();
    maplibregl.addProtocol('pmtiles', protocol.tile);
    document.documentElement.setAttribute('data-app-initialised', true);
  }, []);

  return (
    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <ErrorBoundary>
            <TranslationsProvider translator={translator}>
              <MapSwitch />
              <LocalizedRoutes>
                {routes.map(({ path, element }) => (
                  <Route path={path} element={element} key={path} />
                ))}
              </LocalizedRoutes>
            </TranslationsProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </ThemeProvider>
      <WindowObserver />
    </StoreProvider>
  );
}

export default App;
